import logo from './csbookspdfh.png';
import React from 'react'
import { useState } from "react";
import { Link } from 'react-router-dom';
import "./navbar.css"
import { IoMenuSharp } from "react-icons/io5";
import { FcSearch } from "react-icons/fc";

const Navbar = () => {
  const [isNavExpanded, setIsNavExpanded] = useState(false)
  return (
    <nav className="navbar">
            <div className="logo"> CSBOOKSPDF </div>
            <div className='searchicon'><Link to="/search"><FcSearch size={30}  /> </Link></div>

            <div className="hamburger">
            <a href="#" onClick={() => {setIsNavExpanded(!isNavExpanded);}}>
            <IoMenuSharp size={40} color='white' />
                </a>
            </div>
            <div className={isNavExpanded ? "menu expanded" : "menu"}>
            <ul>
                <li onClick={() => {setIsNavExpanded(!isNavExpanded);}}>
                <Link to="/">Home</Link>
                </li>
                <li onClick={() => {setIsNavExpanded(!isNavExpanded);}}>
                <Link to="/about">About</Link>
                </li>
                <li onClick={() => {setIsNavExpanded(!isNavExpanded);}}>
                <Link to="/search">Search</Link>
                </li>
                <li onClick={() => {setIsNavExpanded(!isNavExpanded);}}>
                <Link to="/contact">Contact</Link>
                </li>
            </ul>
            </div>
           
            
    </nav>

  )
}

export default Navbar